import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const addSchedulesToReviewProject = api(async function addSchedulesToReviewProject({ id, scheduleIds }) {
    return mutate(
        gql`
            mutation AddSchedulesToReviewProject($id: String!, $scheduleIds: [String!]!) {
                addSchedulesToReviewProject(id: $id, scheduleIds: $scheduleIds) {
                    addedCount
                    skippedCount
                    skippedNonCoreCount
                    skippedDuplicateCount
                }
            }
        `,
        { id, scheduleIds },
        { returns: "addSchedulesToReviewProject" }
    )
})
